



import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseNotificationService } from '../base-notification/base-notification.service';
import { NotificationCertification } from './notification-certification.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationCertificationService extends BaseNotificationService<NotificationCertification> {

    constructor(protected http: HttpClient) {
        super(http, 'notificationcertification');
    }

    getAll(): Observable<NotificationCertification[]> {
        return this.http.get<NotificationCertification[]>(this.baseUrl).pipe(
            map(items => items.map(item => Object.assign({ isCertification: true }, item)))
        );
    }
}
